var render, staticRenderFns
import script from "./AuctionListPage.vue?vue&type=script&lang=js"
export * from "./AuctionListPage.vue?vue&type=script&lang=js"
import style0 from "./AuctionListPage.vue?vue&type=style&index=0&id=0fe4ad6d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe4ad6d",
  null
  
)

export default component.exports